import React from 'react';
import st from './style.module.css';

const SkeletonAnimation = Component => {
  return props => <Component {...props} skeletonClass={st.skeleton} />;
};

export default SkeletonAnimation;
